var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-performance',{attrs:{"value":_vm.adaptedValue,"is-mop":_vm.isMop}})
}
var staticRenderFns = []

export { render, staticRenderFns }